import styled from "styled-components";

import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const TransactionBtnV2 = styled(TextButton)({
    width: "auto",
});

export const TransactionBtnWrapper = styled.div<{ isFullWidthCta?: boolean }>(({ theme, isFullWidthCta = false }) => ({
    width: isFullWidthCta ? `calc(100% - ${theme.spacing.x16})` : "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: `${theme.spacing.medium} 40px`,
    borderRadius: theme.spacing.small,
    background: theme.colors[theme.colorMode].primary,
    boxShadow: "0px 3.478px 17.391px 0px rgba(27, 166, 114, 0.08)",
    zIndex: 5,
}));
